<template>
  <section class="should-you-bluff-preflop-steps">
    <set-range-step
      v-for="(player, playerIndex) in players._players"
      v-bind:key="player.id"
      v-bind:ref="'setRangeStep-' + playerIndex"
      v-bind:textForStep="getTextForPlayerRangeStep(playerIndex)"
      v-bind:player="player"
      v-bind:playerIndex="playerIndex"
      v-bind:playerStateIndex="0"
      v-bind:presetCommunityCards="presetCommunityCards"
      v-bind:storeModuleName="'guidedAnalysesBluffing'"
      v-bind:authorized="authorized"
    >
      <range-help-section
        slot="rangeHelpSection"
        v-bind:playerStateIndex="0"
        v-bind:streetToBluff="streetToBluff"
      />
    </set-range-step>
  </section>
</template>

<script>
import SetRangeStep from '@/components/guided-analyses/set-range-step';
import RangeHelpSection from '@/components/guided-analyses/should-you-bluff/help/range';

export default {
  name: 'should-you-bluff-preflop-steps',
  components: {
    'set-range-step': SetRangeStep,
    'range-help-section': RangeHelpSection,
  },
  props: [
    'players',
    'presetCommunityCards',
    'streetToBluff',
    'authorized',
  ],
  methods: {
    getTextForPlayerRangeStep: function (playerIndex) {
      if (this.players.numPlayers === 1) {
        return `Step ${4 + playerIndex}: What do you think your opponents range is after the preflop action is finished (eg. heading in to the flop)?`;
      } else {
        return `Step ${4 + playerIndex}: What do you think opponent #${playerIndex + 1}'s range is after the preflop action is finished (eg. heading in to the flop)?`
      }
    },
    resetDoubleSlider: function (playerIndex) {
      if (this.$refs['setRangeStep-' + playerIndex] && this.$refs['setRangeStep-' + playerIndex][0]) {
        this.$refs['setRangeStep-' + playerIndex][0].resetDoubleSlider(playerIndex);
      }
    },
    resetAllDoubleSliders: function () {
      this.players.forEach(function (player, playerIndex) {
        this.resetDoubleSlider(playerIndex);
      }, this);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/should-you-bluff/preflop-steps.vue